<template>
	<div class="site-external-emails">
		<div class="flex justify-end mb-4">
			<vs-button color="success" type="filled" @click="openModal">{{
				$t("add")
			}}</vs-button>
		</div>
		<vx-card>
			<div class="tab-text">
				<vs-table max-items="5" pagination :data="externalEmailsList">
					<template slot="thead">
						<vs-th
							v-for="fil in field"
							:class="{
								'justify-center':
									fil.align && fil.align === 'center',
							}"
						>
							{{ fil.title }}
						</vs-th>
					</template>

					<template slot-scope="{ data }">
						<vs-tr :key="indextr" v-for="(tr, indextr) in data">
							<template v-for="fil in field">
								<vs-td
									:class="{
										'text-center':
											fil.align && fil.align === 'center',
									}"
									v-if="fil.field === 'email'"
								>
									{{ tr.email }}
								</vs-td>
								<vs-td
									:class="{
										'text-center':
											fil.align && fil.align === 'center',
									}"
									v-if="fil.field === 'imapHost'"
								>
									{{ tr.imap_host || '---' }}
								</vs-td>
								<vs-td
									:class="{
										'text-center':
											fil.align && fil.align === 'center',
									}"
									v-if="fil.field === 'imapPassword'"
								>
									{{ tr.imap_password }}
								</vs-td>
								<vs-td
									:class="{
										'text-center':
											fil.align && fil.align === 'center',
									}"
									v-if="fil.field === 'actions'"
								>
									<div class="flex justify-center">
										<vs-custom-button
											size="small"
											color="#626262"
											type="flat"
											icon-pack="feather"
											@click="openModal(tr, indextr)"
											icon="edit"
										>
											<feather-icon icon="EditIcon">
											</feather-icon>
										</vs-custom-button>

										<vs-custom-button
											size="small"
											color="#626262"
											type="flat"
											icon-pack="feather"
											@click="deleteEmail(tr)"
											icon="edit"
										>
											<feather-icon
												icon="Trash2Icon"
											></feather-icon>
										</vs-custom-button>
									</div>
								</vs-td>
							</template>
						</vs-tr>
					</template>
				</vs-table>
			</div>
		</vx-card>
		<vs-prompt
			@cancel="date = ''"
			@accept="editEmail"
			:active.sync="activePromptEdit"
			:title="'Добавить почту (TODO)'"
			:acceptText="$t('save')"
			:cancelText="$t('cancel')"
			class="template-popup"
		>
			<div class="con-exemple-prompt">
				<div
					class="vs-component vs-con-input-label vs-input vs-input-primary"
				>
					<label class="vs-input--label">E-mail</label>
					<div class="vs-con-input"></div>
					<vs-input
            data-vv-validate-on="blur"
						v-validate="'email|required'"
						v-model="editModel.email"
						name="email"
					/>
				</div>
				<span class="text-danger text-sm">
					<span v-if="errors.first('email')">{{
						$t("fieldFilledIncorrect")
					}}</span
					><br />
				</span>
			</div>
			<div class="con-exemple-prompt">
				<div
					class="vs-component vs-con-input-label vs-input vs-input-primary"
				>
					<label class="vs-input--label">IMAP Host</label>
					<div class="vs-con-input"></div>
					<vs-input
						v-model="editModel.imap_host"
						name="imap_host"
					/>
				</div>
				<span class="text-danger text-sm">
					<span v-if="errors.first('imap_host')">{{
						$t("fieldFilledIncorrect")
					}}</span
					><br />
				</span>
			</div>
			<div class="con-exemple-prompt">
				<div
					class="vs-component vs-con-input-label vs-input vs-input-primary"
				>
					<label class="vs-input--label">IMAP {{ $t('password') }}</label>
					<div class="vs-con-input"></div>
					<vs-input
            data-vv-validate-on="blur"
						v-validate="'required'"
						v-model="editModel.imap_password"
						name="password"
					/>
				</div>
				<span class="text-danger text-sm">
					<span v-if="errors.first('password')">{{
						$t("fieldFilledIncorrect")
					}}</span
					><br />
				</span>
			</div>
		</vs-prompt>
	</div>
</template>

<script>
import notifier from "../../mixins/notifier";

export default {
	name: "SiteExternalEmails",
	mixins: [notifier],

	props: {
		model: { required: true },
		validate: { required: true, type: Boolean },
	},

	data() {
		return {
			externalEmails: [],
			editModel: {},
			activePromptEdit: false,
      activeEditItem: null,
		};
	},

	computed: {
		externalEmailsList() {
			return this.model.external_emails || [];
		},
	},

	created() {
		this.field = [
			{
				field: "email",
				title: "E-mail",
				align: "start",
			},
			{
				field: "imapHost",
				title: `IMAP Host`,
				align: "start",
			},
			{
				field: "imapPassword",
				title: `IMAP ${this.$t('password')}`,
				align: "start",
			},
			{
				field: "actions",
				title: this.$t("actions"),
				align: "center",
			},
		];
	},

	methods: {
		openModal(tr, index) {
			if (tr) {
				this.editModel = JSON.parse(JSON.stringify(tr));
        this.activeEditItem = index
			} else {
				this.editModel = {
					email: "",
					imap_host: "",
					imap_password: "",
				};
			}
			this.activePromptEdit = true;
		},
		async editEmail() {
      this.$validator.resume();
      let validator = await this.$validator.validateAll();
      this.$validator.pause();

      if(!validator) return this.activePromptEdit = true;

      if (this.activeEditItem !== null && this.activeEditItem !== undefined) {
        this.$set(this.model.external_emails, this.activeEditItem, this.editModel)
      } else {
        const index = this.model.external_emails.length;
        this.$set(this.model.external_emails, index, this.editModel);
      }
      this.activeEditItem = null
		},
		deleteEmail(tr) {
        const index = this.model.external_emails.indexOf(tr);
        this.model.external_emails.splice(index, 1);
		},
	},
};
</script>

<style lang="scss">
.site-external-emails {
  .justify-center .vs-table-text{
      justify-content: center;
  }

}
</style>
